module.exports = __webpack_public_path__ + "img/img94.f673a3b5.svg";